import Page from "@/features/Page/Page";
import BreadcrumbsInlab, {BreadcrumbLink} from "@/components/BreadcrumbsInlab/BreadcrumbsInlab";
import UrlsConfig from "@/config/UrlsConfig";
import PageHeading from "@/features/PageHeading/PageHeading";
import {useTranslation} from "react-i18next";
import { Helmet } from "react-helmet";
import { titleSuffix } from "@/config/Other";

const Page404 = () => {

    const { t } = useTranslation();

    const urlsConfig = new UrlsConfig();
    const breadLinks: BreadcrumbLink[] = [
        {
            title: t("Index"),
            to: urlsConfig.index.to
        },
        {
            title: t("Page not found"),
            to: urlsConfig.page404.to
        }
    ];

    return (
        <>
            <Helmet>
                <title>{t("Page not found")}{titleSuffix}</title>
            </Helmet>
            
            <BreadcrumbsInlab links={breadLinks} />
            <Page>
                <PageHeading>{t("Page not found")}.</PageHeading>
            </Page>
        </>

    )
};

export default Page404;